<template>
  <div class="renewal_page">
    <!-- 搜索框 -->
    <div class="search_bar">
      <!-- <div style="width: 100%;"> -->
        <div class="search_inp">
          <span class="search_icon"></span>
          <input v-model="queryParams.searchWord"
                type="text"
                placeholder="投被保险人/订单号/产品名称"
                @input="debounceFetch(false)">
        </div>
        <ul class="tab_bar">
          <li v-for="(item,index) in tabList"
              :key="index"
              @click="changeTab(index)">
            <span class="tab_name"
                  :class="{active: activeBarIndex == index}">{{item.text}}</span>
            <img v-if="activeBarIndex == index"
                src="../../../assets/image/nsale/tabSelected.png"
                class="tab_selected" />
          </li>
        </ul>
      <!-- </div> -->
      <!-- 总保费 -->
      <div class="total_amout">
        <div class="inner_">
          <p>累计<span class="red_">{{totalPolicyNum}}</span>单，总保费<span class="red_">{{totalPremium}}</span>元</p>
        </div>
      </div>
    </div>
    <!-- 订单列表 -->
    <div class="order_list"
         v-if="orderList.length > 0">
      <div class="order_item"
           v-for="(item,index) in orderList"
           :key="index">
        <div class="item_line">
          <span class="title_">{{item.productName}}</span>
        </div>
        <div class="item_line2">
          <span>投保人：</span>
          <span>{{item.holderName || '-'}}</span>
        </div>
        <div class="item_line2">
          <span>投保时间：</span>
          <span>{{item.createDate || '-'}}</span>
        </div>
        <div class="item_line2">
          <span>订单号：</span>
          <span>{{item.policyId || '-'}}</span>
        </div>
        <div class="item_line2"
             style="display: flex;justify-content: space-between;">
          <div>
            <span>保费：</span>
            <span>{{item.premium && item.premium+'元' || '-'}}</span>
          </div>
          <!-- <div>
            <span>收入：</span>
            <span style="color: #333333;font-weight: 500;">¥</span>
            <span style="color: #333333;font-weight: 500;font-size:18px;margin-left: 3px;">{{item.commissionAmount}}</span>
          </div> -->
        </div>
        <div class="item_bottom">
          <div class="item_left">
            <div class="item_time stauts_14"
                 v-if="item.status == 14 || item.status == 15">
              {{item.status | filterStatus}}
            </div>
            <div class="item_time stauts_2"
                 v-if="item.status == '-2'">
              {{item.status | filterStatus}}
            </div>
            <div class="item_time stauts_32"
                 v-if="item.status == 11 || item.status == 32 || item.status == 3" >
              {{item.status | filterStatus}}
            </div>
            <div class="item_time stauts_0"
                 v-if="item.status == 0 || item.status == 17 || item.status == 4 || item.status == 5 || item.status == 6">
              {{item.status | filterStatus}}
            </div>
          </div>
          <div class="btns">
            <button class="grey_ mr10_"
                    v-if="showCanleBtn(item)"
                    @click="deletePolicyByUserId(item.policyId, 'cancle')">取消订单</button>
            <button class="grey_ mr10_"
                    v-if="showRevokeBtn(item)"
                    @click="deletePolicyByUserId(item.policyId, 'revoke')">撤单</button>
            <button class="red_"
                    v-if="showViewDetailBtn(item)"
                    @click="showDetail(item.policyId,item.status,item)">查看详情</button>
            <button class="red_"
                    v-if="item.status == '-2' || item.status == '0' || item.status == '17'"
                    @click="queryWechatUrl(item)">继续投保</button>
          </div>
        </div>
      </div>
    </div>
    <div class="order_list_empty"
         v-else>
      无相关的数据
    </div>
    <div class="fix_bg" v-if="isShowMask">
      <div class="box_">
        <p style="text-align: center;">{{title}}</p>
        <div class="btns_">
          <button class="sure_" @click="confirm">确定</button>
          <button @click="cancel">取消</button>
        </div>
      </div>
    </div>
    <p v-if="nomore && orderList.length > 0"
       class="nomore">没有更多了</p>
  </div>
</template>
<script>
import { debounce } from '@/utils/debounce.js'
import api from '@/utils/api'
import moment from 'moment'
const positions = ['bottom']
let cur = 0
let maxDate = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
let strDatepart = maxDate.split('-')
export default {
  data () {
    document.title = '待处理订单'
    return {
      tabList: [
        {
          value: 0,
          text: '全部'
        },
        {
          value: 1,
          text: '待付款'
        },
        {
          value: 2,
          text: '核保中'
        }
      ],
      activeBarIndex: 0,
      orderList: [],
      isShowMask: false,
      position: '',
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        searchWord: '',
        status: '', // 1 可续保 2 不可续保 默认查询可续保列表
        userId: '',
        // morePolicy: false,
        // startDate: '',
        // endDate: '',
        pages: ''
      },
      title: '确定取消订单？',
      mainId: '',
      userId: '',
      clientHeight: 0, // 可视区的高度
      scrollTop: 0, // 滚动条滚动时，距离顶部的距离
      scrollHeight: 0, // 滚动条的总高度
      nomore: false,
      hasMore: false, // 是否展示查看未续保保单按钮
      totalPolicyNum: '',
      totalPremium: '',
      policyId: ''
    }
  },
  methods: {
    moment,
    // 显示取消订单按钮
    showCanleBtn(item) {
      // 妈咪保贝（新生版）productCode=110093;
      if (item.productCode != '110093' && (item.status=='-2'||item.status=='0' || item.status == '17')) {
        return true
      }
      if (item.productCode == '110093' && (item.status=='-2'||item.status=='0')) {
        return true
      }
      return false
    },
     // 显示查看详情订单
    showViewDetailBtn(item){
      let statusList = ['3', '4', '5','6','11','14','15','32'];
      if (statusList.indexOf(item.status) > -1) {
        return true;
      }
      return false;
    },
    // 显示撤单按钮
    showRevokeBtn(item) {
      // 妈咪保贝（新生版）productCode=110093;
      if (item.productCode == '110093' && (item.status=='17'||item.status=='32'||item.status=='4'||item.status=='5'||item.status=='6')) {
        return true
      }
      return false
    },
    changeTab (index) {
      window.scrollTo(0, 0)
      this.activeBarIndex = index
      // this.queryParams.searchName = ''
      // this.queryParams.morePolicy = false
      if (this.activeBarIndex == 0) {
        this.queryParams.status = ''
      } else if (this.activeBarIndex == 1) {
        this.queryParams.status = '0,17'
      } else {
        this.queryParams.status = '11,32'
      }
      this.fetchData(false)
      this.queryTotalCountAndPremium()
    },
    debounceFetch: debounce(function (props) {
      this.nomore = false
      this.fetchData(false)
      this.queryTotalCountAndPremium()
    }, 1000),
    fetchData (flag) {
      console.log('----------')
      if (!flag) {
        this.clearData()
      }
      this.getOrderList(flag)
    },
    clearData () {
      this.queryParams.pageNum = 1
      this.queryParams.pages = ''
      this.nomore = false
    },
    cancel () {
      this.isShowMask = false
    },
    confirm () {
      // 取消订单
      if (this.title == '确定取消订单？') {
        this.cancelPolicy();
      }
      // 撤单
      if (this.title == '确定撤单？') {
        this.revokePolicy();
      }
     
    },
    // 取消订单接口
    cancelPolicy() {
       let params = {
        policyId: this.policyId,
        userId: this.userId
      }
      api.cancelOrder(params).then(res => {
        this.$toast('订单已取消')
        this.isShowMask = false
        this.fetchData(false)
      })
    },
    // 撤单接口
    revokePolicy() {
      api.cancelPolicy({ policyId: this.policyId }).then((res) => {
        let data = res.data;
        if (data.returnCode == '0000') {
          this.$toast('撤销成功')
          this.isShowMask = false
          this.fetchData(false)
          return;
        }
        this.$toast(res.returnMsg);
      })
    },
    // 查询续保订单
    getOrderList (flag) {
      if (!flag) {
        this.clearData()
      }
      this.queryParams.userId = this.userId
      console.log(this.queryParams)
      api.getOrderList(this.queryParams).then(res => {
        if (!flag) {
          this.orderList = res.data.content.orderList || []
        } else {
          this.orderList = this.orderList.concat(res.data.content.orderList || [])
        }
        this.hasMore = res.data.content.hasMore
        this.queryParams.pages = Math.ceil((res.data.content.total || 0) / this.queryParams.pageSize)
        this.queryParams.total = res.data.content.total
      })
    },
    showDetail (policyId, status, data) {
      let isOneClickRenewal = 'N'
      this.$router.push({
        path: '/bs/orderDetail',
        query: {
          policyId: policyId,
          status: status,
          isOneClickRenewal: isOneClickRenewal,
          productName: data.productName

        }
      })
    },

    deletePolicyByUserId (policyId, type) {
      this.isShowMask = true
      this.policyId = policyId
      this.title = type == 'cancle' ? '确定取消订单？' : '确定撤单？'
    },
    listenerFunction () {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop// 滚动条滚动时，距离顶部的距离
      this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight// 可视区的高度
      this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight// 滚动条的总高度
      if (this.scrollTop + this.clientHeight + 150 >= this.scrollHeight) {
        // window.scrollTo(this.scrollTop - 20, 0);
        this.timer = setTimeout(() => { // 延迟500ms加载数据
          console.log(this.queryParams)
          this.pageChange()
        }, 500)
      }
    },
    pageChange () {
      if (this.queryParams.pageNum < this.queryParams.pages) {
        this.queryParams.pageNum++
        this.fetchData(true)
      } else {
        this.nomore = true
      }
    },
    // 查询续保订单
    queryTotalCountAndPremium () {
      api.queryTotalCountAndPremium(this.queryParams).then(res => {
        this.totalPolicyNum = res.data.content.totalPolicyNum
        this.totalPremium = res.data.content.totalPremium
      })
    },
    // 跳转投保前黑名单校验
    async validBlackList(item) {
      let flag = false
      await api.verifyWhetherVisitorProductPage(this.userId, item.productCode).then(res => {
        if (res.data.returnCode == '0000' && res.data.content == 'Y') {
					flag = true
			  } else {
          this.$toast('账号暂无该产品出单权限')
        }
      })
      return flag
    },
    async queryWechatUrl (item) {
      let flag = await this.validBlackList(item)
      if(!flag) {
        return
      }
      api.queryWechatUrl({ policyId: item.policyId }).then(res => {
        if (res.data.returnCode == '0000') {
          window.location.href = res.data.content
        } else {
          this.$toast(res.data.returnMsg)
        }
      })
    }
  },
  mounted () {
    let { mainId, userId } = this.$route.query
    this.mainId = mainId
    this.userId = userId
    this.getOrderList()
    this.queryTotalCountAndPremium()
  },
  created () {
    window.addEventListener('scroll', this.listenerFunction)
  },
  destroyed () {
    window.removeEventListener('scroll', this.listenerFunction)
  },
  filters: {
    filterStatus (val) {
      if (val == '14' || val == '15') {
        return '核保失败'
      } else if (val == '-2') {
        return '待完善'
      } else if (val == '11' || val == '32') {
        return '核保中'
      } else if (val == '0' || val == '17') {
        return '待支付'
      } else if (val == '3') {
        return '已支付投保失败'
      } else if (val == '4') {
        return '拒保延期'
      } else if (val == '5') {
        return '待复核'
      } else if (val == '6') {
        return '问题件'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.renewal_page {
  background: #f8f8f8;
  padding: 118px 0 60px;
  min-height: 100vh;
  .search_bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    // padding: 0 20px;
    background: #fff;
    .search_inp {
      position: relative;
      background: #f5f5f5;
      height: 35px;
      border-radius: 7px;
      margin: 10px 20px 0;
      .search_icon {
        position: absolute;
        top: 50%;
        left: 11px;
        transform: translateY(-43%);
        width: 13px;
        height: 13px;
        background: url(../../../assets/image/nsale/search2.png) center center
          no-repeat;
        background-size: 100% 100%;
      }
      input {
        position: absolute;
        width: 90%;
        height: 35px;
        top: 0;
        left: 30px;
        background: #f5f5f5;
        border-radius: 7px;
        font-size: 12px;
        color: #ccc;
        &:focus {
          outline: none;
          border: none;
          color: #333;
        }
      }
    }
    .tab_bar {
      display: flex;
      align-items: center;
      height: 44px;
      margin: 0 20px;
      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        .tab_name {
          font-size: 13px;
        }
        .tab_selected {
          width: 19px;
          height: 5px;
          margin-top: 3px;
        }
        .active {
          font-size: 15px;
          font-weight: 500;
          line-height: 21px;
        }
      }
    }
    .date_select {
      display: flex;
      height: 49px;
      .date_left {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin: 0 3px 0 16px;
        }
        .date_choose {
          color: #333333;
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }
  .total_amout {
    // position: fixed;
    // top: 100px;
    // left: 0;
    // margin-top: 10px;
    font-size: 0.32rem;
    color: #999999;
    background: #f8f8f8;
    width: 100%;
    text-align: left;
    padding-top: 10px;
    height: 37px;
    .inner_ {
      display: flex;
      align-items: center;
      height: 100%;
      background: #fff;
      padding-left: 16px;
      border-radius: 4px;
      margin: 0 20px;
      .red_ {
        color: #ff7c6d;
      }
    }
  }
  .order_list {
    margin-top: 20px;
    border-radius: 7px;
    padding: 0 20px;
    .order_item {
      background: #fff;
      padding: 18px 16px 13px;
      border-radius: 7px;
      margin-bottom: 15px;
      .item_line {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        .title_ {
          line-height: 23px;
          color: #333333;
          font-size: 15px;
          font-weight: 600;
          text-align: left;
          flex: 5;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .tips_ {
          flex: 3;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          text-align: right;
        }
        .tips_yellow {
          color: #ffaa4d;
        }
        .tips_red {
          color: #ff7c6d;
        }
      }
      .item_line2 {
        color: #666;
        font-size: 12px;
        text-align: left;
        margin-top: 4px;
        height: 17px;
        line-height: 17px;
      }
      .item_bottom {
        margin-top: 17px;
        border-top: 1px solid #ececec;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
        .item_left {
          // flex: 2;
          // flex-wrap: wrap;
          text-align: left;
          // height: 27px;
          .item_time {
            color: #666;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 4px;
          }
          .item_reason {
            color: #999999;
            font-size: 12px;
            line-height: 17px;
          }
          .stauts_14 {
            color: #ff7c6d;
          }
          .stauts_2 {
            color: #5599ff;
          }
          .stauts_32 {
            color: #999999;
          }
          .stauts_0 {
            color: #ffaa4d;
          }
        }
        .btns {
          display: flex;
          align-items: center;
        // flex: 3;
        button {
          height: 27px;
          border-radius: 4px;
          border: none;
          min-width: 60px;
          &:focus {
            outline: none;
            border: none;
          }
        }
        .grey_ {
          background: #eaeaea;
          color: #666666;
        }
        .red_ {
          background: #ff7c6d;
          color: #fff;
        }
        }
      }
      .mR10 {
        margin-right: 10px;
      }
    }
  }
  .order_list_empty {
    font-size: 14px;
    margin-top: 50px;
  }
  .nomore {
    font-size: 14px;
    color: #999;
  }
  .more_ {
    position: fixed;
    bottom: 14px;
    width: 100%;
    height: 45px;
    border-radius: 7px;
    padding: 0 20px;
    .more_btn {
      width: 100%;
      height: 100%;
      background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
      border-radius: 7px;
      border: none;
      color: #fff;
      font-size: 15px;
      font-weight: 500;
      &:focus {
        outline: none;
        border: none;
      }
    }
  }
  .mask_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .mask_con {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 224px;
      width: 100%;
      background: #fff;
      border-radius: 10px 10px 0px 0px;
      .title_ {
        position: relative;
        width: 100%;
        height: 45px;
        line-height: 45px;
        background: #f9f9f9;
        border-radius: 10px 10px 0px 0px;
        .date_text {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 15px;
          color: #333;
          text-align: center;
        }
        .date_cancel {
          position: absolute;
          right: 16px;
          font-size: 13px;
          color: #666666;
          text-align: right;
        }
      }
      .date_select {
        margin-top: 24px;
        input {
          width: 142px;
          height: 45px;
          background: #f9f9f9;
          border-radius: 7px;
          font-size: 13px;
          color: #999999;
          text-align: center;
          &:focus {
            outline: none;
          }
        }
        .to_ {
          color: #333333;
          font-size: 14px;
          margin: 0 20px;
        }
      }
      .date_btns {
        margin-top: 29px;
        .reset_btn {
          width: 136px;
          height: 45px;
          border-radius: 7px;
          border: 1px solid #ff7f71;
          background: #fff;
          color: #ff7f70;
          &:focus {
            outline: none;
          }
        }
        .comfirm_btn {
          width: 188px;
          height: 45px;
          background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
          border-radius: 7px;
          border: none;
          color: #fff;
          margin-left: 10px;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .recommend_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .recommend_box {
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      border-radius: 7px;
      background: #fff;
      padding-bottom: 46px;
      max-height: 350px;
      overflow: scroll;
      // height: 100px;
      .close_ {
        color: #000;
        font-size: 16px;
        text-align: right;
        margin: 16px 20px 15px 0;
      }
      .recommend_item {
        display: flex;
        margin: 0 29px 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .pro_left {
          position: relative;
          width: 88px;
          height: 112px;
          background: #eee;
          border-radius: 7px;
          img {
            width: 88px;
            height: 112px;
            border-radius: 7px;
          }
          .left_top_tag {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            height: 13px;
            line-height: 13px;
            background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
            border-radius: 7px 0px 7px 0px;
            opacity: 0.9;
            color: #fff;
            font-size: 8px;
            text-align: center;
          }
          .short_name {
            position: absolute;
            bottom: 0;
            width: 88px;
            height: 18px;
            line-height: 18px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 0px 0px 7px 7px;
            font-size: 11px;
            color: #fff;
          }
        }
        .pro_right {
          margin-left: 9px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 80%;
          .pro_right_top {
            .pro_name {
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              line-height: 21px;
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .pro_tag {
              margin-top: 5px;
              font-size: 12px;
              color: #666;
              text-align: left;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .pro_right_bottom {
            .pro_score {
              width: 104px;
              height: 18px;
              line-height: 18px;
              background: #f0f0f0;
              border-radius: 10px;
              font-size: 11px;
              color: #666;
              font-weight: 500;
              text-align: center;
              // margin-bottom: 5px;
            }
            .foot_ {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 29px;
              .unit_ {
                font-size: 9px;
                color: #ff4a35;
              }
              .price_ {
                font-size: 18px;
                color: #ff4a35;
                line-height: 25px;
                margin: 0 2px 0;
              }
              .unit_2 {
                color: #666666;
                font-size: 10px;
              }
              button {
                width: 61px;
                height: 19px;
                background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
                border-radius: 7px;
                border: 0;
                color: #fff;
                font-size: 10px;
                font-weight: 500;
                &:focus {
                  outline: none;
                  border: none;
                }
              }
            }
          }
        }
      }
    }
  }
  .calendar_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    .calendar {
      width: 100%;
      height: 485px;
      position: absolute;
      background: #fff;
      bottom: 0;
      left: 0;
      border-radius: 10px 10px 0px 0px;
      // padding-bottom: 27px;
      .cancel_ {
        color: #666666;
        font-size: 13px;
      }
      .choose_date {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #333333;
        font-size: 15px;
      }
      .confim_ {
        color: #ff7c6d;
        font-size: 13px;
      }
      .calendar_title {
        position: relative;
        padding: 0 17px;
        display: flex;
        justify-content: space-between;
        height: 45px;
        line-height: 45px;
        margin-bottom: 10px;
        background: #f9f9f9;
        border-radius: 10px 10px 0px 0px;
      }
      .calendar_current_month {
        // height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0 25px;
        .pre_month {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          line-height: 22px;
          background: #f3f3f3;
          border-radius: 5px;
          font-size: 8px;
        }
        .current_date {
          color: #333333;
          font-size: 12px;
          margin: 0 17px;
        }
        .next_month {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 22px;
          height: 22px;
          line-height: 22px;
          background: #f3f3f3;
          border-radius: 5px;
          font-size: 8px;
        }
        .arrow_ {
          width: 8px;
          height: 8px;
        }
      }
      // .bgImg {
      //   width: 100%;
      // }
      // .hide {
      //   position: absolute;
      //   top: 30px;
      //   left: 30px;
      //   font-size: 16px;
      //   color: #8C8C8C;
      // }
      // .title {
      //   position: absolute;
      //   top: 35px;
      //   left: 50%;
      //   font-size: 16px;
      //   transform: translate(-50%)
      // }
      .calendar-week {
        width: 100%;
        // position: absolute;
        top: 74px;
        font-size: 15px;
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        padding: 0 20px;
      }
      .calendar-week-item {
        width: 14.285%;
        text-align: center;
        display: inline-block;
        color: rgba(52, 72, 94, 0.54);
        font-size: 12px;
      }
      .right {
        position: absolute;
        top: 35px;
        right: 100px;
        width: 16px;
        height: 16px;
      }
      .left {
        position: absolute;
        top: 35px;
        left: 100px;
        width: 16px;
        height: 16px;
      }
      .calendarDate {
        width: 100%;
        padding: 0 20px;
        // border-bottom: 1px solid #E7E7E7;
        // position: absolute;
        // top: 105px;
        text-align: left;
        .date {
          display: inline-block;
          width: 14.285%;
          font-size: 11px;
          color: #666666;
          // height: 45px;
          text-align: center;
          margin-bottom: 5px;

          &:last-child {
            margin-bottom: 30px;
          }
          &:nth-child(7n) {
            color: #ff7c6d;
          }
          .date_con {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .free {
              margin-top: 10px;
              color: #4098f9;
            }
            .busy {
              margin-top: 10px;
              color: #ff6633;
            }
          }
        }
        .active {
          color: #fff;
          width: 34px;
          height: 34px;
          border-radius: 17px;
          margin-left: 6px;
          background: linear-gradient(45deg, #ff7c6c 0%, #ffa297 100%);
        }
        .disabled_ {
          color: #34485e8a;
          font-size: 11px;
        }
      }
      .line_ {
        margin: 0 20px 20px;
        height: 1px;
        background: #e7e7e7;
      }
      .btns {
        padding: 0 45px;
        display: flex;
        justify-content: space-between;
        button {
          width: 126px;
          height: 40px;
          border-radius: 5px;
          border: none;
          &:focus {
            outline: none;
            border: none;
          }
        }
        .today_ {
          color: #666666;
          background: #eaeaea;
        }
        .confirm_ {
          color: #fff;
          background: #ff7c6d;
        }
      }
      .call_ {
        position: absolute;
        bottom: 30px;
        left: 20%;
        font-size: 12px;
        .tel {
          color: #4167f2;
        }
      }
    }
  }
  .fix_bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    .box_ {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 330px;
      height: 150px;
      background: #fff;
      border-radius: 7px;
      padding: 32px 29px 22px;
      p {
        color: #333;
        font-size: 15px;
        text-align: left;
      }
      .btns_ {
        display: flex;
        justify-content: space-around;
        .sure_ {
          color: #fff;
          background: #FF7C6D;
        }
        button {
        width: 126px;
        height: 40px;
        font-size: 15px;
        border: none;
        outline: none;
        color: #666;
        background: #EAEAEA;
        border-radius: 5px;
        &:focus {
          border: none;
          outline: none;
        }
      }
      }

    }
  }
  .mr10_ {
    margin-right: 10px;
  }
}
</style>
